/* Wildtree: make product-info talk to the MAIN product form.
   The theme's default getter returns the first <product-form> inside <product-info>, which on this
   page is an adapter card's quick-add form. That made color changes toggle the wrong Add to cart button. */
(function () {
  function patch() {
    var C = customElements.get('product-info');
    if (!C || C.prototype.__wtFormFix) return;
    var original = Object.getOwnPropertyDescriptor(C.prototype, 'productForm');
    Object.defineProperty(C.prototype, 'productForm', {
      configurable: true,
      get: function () {
        var mainForm = this.querySelector('#product-form-' + this.dataset.section);
        var wrapper = mainForm && mainForm.closest('product-form');
        if (wrapper) return wrapper;
        return original && original.get ? original.get.call(this) : this.querySelector('product-form');
      },
    });
    C.prototype.__wtFormFix = true;
  }
  if (customElements.get('product-info')) patch();
  else customElements.whenDefined('product-info').then(patch);
})();
